export default __webpack_public_path__ + "static/media/video2.0fd3d3e9.mp4";